<script>
    import mixin from './../mixin';
    import bulmaCollapsible from '@creativebulma/bulma-collapsible';
    import { discountStore } from './../store/discountStore.js';
    import { userStore } from './../store/userStore.js';
    import Swal from 'sweetalert2/dist/sweetalert2.js';

    const swalWithBulmaButtons = Swal.mixin({
        customClass: {
            confirmButton: "button is-secondary is-rounded is-small mr-2",
            cancelButton: "button is-secondary is-outlined is-rounded is-small ml-2"
        },
        buttonsStyling: false
    });

    export default {
        props: {
            plans: {
                type: Array,
                default: () => []
            },
            userApi : {
                type: String,
                default: '/api/user'
            },
            loginUrl: {
                type: String,
                default: ''
            },
            culture: {
                type: String,
                default: 'nl-NL'
            },
            currentUrl: {
                type: String,
                default: ''
            },
            purchaseApi: {
                type: String,
                default: ''
            },
            cardClass: {
                type: String,
                default: ''
            },
            buttonTxt: {
                type: String,
                default: 'Kies'
            },
            subscriptionOwnedTxt: {
                type: String,
                default: 'Abonnement actief'
            },
            noResultsTxt: {
                type: String,
                default: 'Geen abonnementen gevonden'
            },
            percentual : {
                type: String,
                default: 'Percentual'
            },
            fixed : {
                type: String,
                default: 'Fixed'
            },
            reactivateTxt: {
                type: String,
                default: 'Reactiveer'
            },
            cancelledTxt: {
                type: String,
                default: 'Stopgezet'
            },
            generalErrorTxt: {
                type: String,
                default: 'Er is iets misgegaan. Probeer het later opnieuw.'
            },
            swalTitle: {
                type: String,
                default: 'Weet u het zeker?'
            },
            swalTxt: {
                type: String,
                default: 'U heeft al een actief abonnement. Uw {{subscription}} abonnement wordt stopgezet. Het nieuwe abonnement gaat in per {{subscriptionDate}}.'
            },
            swalProceed: {
                type: String,
                default: 'Doorgaan'
            },
            swalCancel: {
                type: String,
                default: 'Annuleren'
            },
            removeSubscriptionApi : {
                type: String,
                default: '/api/member/customersubscriptions'
            },
        },
        mixins: [mixin],
        data() {
            return {
                loadPayment: false,
                purchaseError: false
            }
        },
        computed: {
            discount() {
                return discountStore.state;
            },
            user() {
                return userStore.user;
            },
            loggedIn() {
                return userStore.loggedIn;
            }
        },
        methods: {
            hasDiscount(id) {
                return this.discount.filter(discount => discount.forProductId === id).length;
            },
            discountPrice(price, id) {
                let foundDiscount = this.discount.find(discount => discount.forProductId === id);
                if (foundDiscount && foundDiscount.priceModifier) {
                    let priceNumeric = parseFloat(price);
                    let modifier = parseFloat(foundDiscount.priceModifier);
                    return foundDiscount.priceModifierTypeAlias === this.percentual ? this.toDutchCurrency(priceNumeric * modifier) : this.toDutchCurrency(priceNumeric + modifier);
                } else {
                    return null;
                }
            },
            async resolvePayment(id) {
                if (this.loggedIn) {
                    this.loadPayment = true;
                    if (this.user.hasSubscription && this.user.activeSubscription.subscriptionId !== id) {
                        let self = this;
                        let txt = this.swalTxt.replace('{{subscription}}', this.user.activeSubscription.subscriptionTitle).replace('{{subscriptionDate}}', this.toFullDateStr(this.user.activeSubscription.end, this.culture));
                        swalWithBulmaButtons.fire({
                            scrollbarPadding: false,
                            title: self.swalTitle,
                            text: txt,
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: self.swalCancel,
                            confirmButtonText: self.swalProceed
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                let removeApi = this.removeSubscriptionApi;
                                const removeSubsriptionResponse = await this.fetchApiData(removeApi, '', 'delete');
                                if (removeSubsriptionResponse && removeSubsriptionResponse.status === 200) {
                                    if (removeSubsriptionResponse.data && removeSubsriptionResponse.data.typeAlias == 'Success') {
                                        const memberResponse = await this.fetchApiData(this.userApi, '', 'get');
                                        if (memberResponse && memberResponse.data.id !== null && memberResponse.status === 200) {
                                            userStore.updateUser(memberResponse.data);
                                            this.molliePayment(id);
                                        } else {
                                            Swal.fire({
                                                title: 'Error!',
                                                text: this.generalErrorTxt,
                                                icon: 'error'
                                            });
                                        }
                                    } else {
                                        Swal.fire({
                                            title: 'Error!',
                                            text: this.generalErrorTxt,
                                            icon: 'error'
                                        });
                                    }
                                } else {
                                    Swal.fire({
                                        title: 'Error!',
                                        text: this.generalErrorTxt,
                                        icon: 'error'
                                    });
                                }
                            } else {
                                this.loadPayment = false;
                            }
                        });
                    } else {
                        this.molliePayment(id);
                    }
                } else {
                    window.location.href =  this.loginUrl + '?starturl=' + this.currentUrl;
                }
            },
            async molliePayment(id) {
                let discountArray = [];
                let foundDiscount = this.discount.find(discount => discount.forProductId === id);
                if (foundDiscount) {
                    discountArray.push(foundDiscount.id);
                }
                let query = {
                    'SubscriptionID': id,
                    'StartUrl': this.currentUrl,
                    'DiscountCodes': discountArray,
                    'LanguageID': this.culture
                };
                const payResponse = await this.fetchApiData(this.purchaseApi, query, 'post');
                if (payResponse) {
                    if (payResponse.status === 200 && payResponse.data) {
                        if (payResponse.data.success) {
                            if (payResponse.data.paymentUrl) {
                                window.location.href = payResponse.data.paymentUrl;
                            } else {
                                this.purchaseError = true;
                            }
                        } else {
                            this.purchaseError = true;
                        }
                    } else {
                        this.purchaseError = true;
                    }
                } else {
                    this.purchaseError = true;
                }
                this.loadPayment = false;
            }
        },
        mounted() {
            this.$nextTick(() => {
                const bulmaCollapsibleInstancesVue = bulmaCollapsible.attach('.is-collapsible--vue');

                bulmaCollapsibleInstancesVue.forEach(bulmaCollapsibleInstance => {
                    bulmaCollapsibleInstance.on('after:expand', function () {
                        bulmaCollapsibleInstance._originalHeight = bulmaCollapsibleInstance.element.scrollHeight + 'px';
                    });
                });
            });
        }
    }
</script>

<template>
    <div>
        <div class="columns is-multiline" v-if="plans.length">
            <div class="column is-half-tablet is-one-third-widescreen" v-for="plan in plans" :key="plan.id">
                <div :class="['widget-subscription-item', 'p-5', 'is-flex', 'is-flex-drection-column', cardClass]">
                    <span class="tag is-secondary is-medium has-tex-weight-bold mb-3" v-if="plan.planEndDate">{{ cancelledTxt }}</span>
                    <span class="tag is-secondary is-medium has-tex-weight-bold mb-3" v-else-if="plan.topLabel">{{ plan.topLabel }}</span>
                    <h3 class="title is-5" v-if="plan.title">{{ plan.title }}</h3>
                    <div v-if="plan.price || plan.subtitle">
                        <span :class="['widget-subscription-price', hasDiscount(plan.id) ? 'is-strikethrough is-small' : '']" v-if="plan.price"> {{ toDutchCurrency(plan.price.amount) }}</span>
                        <span class="widget-subscription-discount" v-if="hasDiscount(plan.id)">{{ discountPrice(plan.price.amount, plan.id) }}</span>
                        <span class="widget-subscription-validity" v-if="plan.subtitle">{{ plan.subtitle }}</span>
                    </div>
                    <ul class="icon-list" v-if="plan.usps">
                        <li v-for="usp in plan.usps">
                            <span class="icon">
                                <i :class="['fa-fw', 'fa-lg', usp.icon]"></i>
                            </span>
                            <span>{{ usp.text }}</span>
                        </li>
                    </ul>
                    <div class="my-2" v-if="plan.underUspText" v-html="plan.underUspText"></div>
                    <template v-if="plan.paymentDetailTitle">
                        <a :href="'#paymentDetails-'+plan.id" data-action="collapse" class="is-block has-text-link-dark is-not-underlined has-text-weight-bold collapse-trigger collapse-trigger-readmore my-3" v-if="plan.paymentDetailDescription">
                            <span class="is-underlined" :data-readmore="plan.paymentDetailTitle" :data-readless="plan.paymentDetailTitle">{{ plan.paymentDetailTitle }}</span>
                            <span class="icon">
                                <i class="fa-solid fa-chevron-down"></i>
                            </span>
                        </a>
                        <span class="has-text-weight-bold mb-3 is-block" v-else>
                            {{ plan.paymentDetailTitle }}
                        </span>
                    </template>
                    <template v-if="plan.paymentDetailDescription">
                        <div :id="'paymentDetails-'+plan.id" class="is-collapsible is-collapsible--vue mb-3" v-html="plan.paymentDetailDescription" v-if="plan.paymentDetailTitle"></div>
                        <div class="mb-3" v-html="plan.paymentDetailDescription" v-else></div>
                    </template>
                    <button @click="resolvePayment(plan.id)" class="button is-secondary is-rounded is-fullwidth is-small mt-auto" :disabled="loadPayment" v-if="!plan.userSubscribed">
                        <span>{{ buttonTxt }}</span>
                        <span class="icon" v-if="loadPayment">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                        </span>
                    </button>
                    <template v-else>
                        <button @click="resolvePayment(plan.id)" class="button is-secondary is-rounded is-fullwidth is-small mt-auto" :disabled="loadPayment" v-if="plan.planEndDate">
                            <span>{{ reactivateTxt }}</span>
                            <span class="icon" v-if="loadPayment">
                                <i class="fa-solid fa-spinner fa-spin"></i>
                            </span>
                        </button>
                        <button class="button is-secondary is-rounded is-fullwidth is-small mt-auto" disabled v-else>
                            {{ subscriptionOwnedTxt }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
        <div class="has-text-centered content" v-else>
            <p> {{ noResultsTxt }}</p>
        </div>
        <div class="content" v-if="purchaseError">
            <p class="has-text-danger"> {{ generalErrorTxt }}</p>
        </div>
    </div>
</template>